
export const LIFE_COVER_OPTIONS = [
  { value: "500000", label: "AED 500,000" },
  { value: "1000000", label: "AED 1,000,000" },
  { value: "2500000", label: "AED 2,500,000" },
]

export const POLICY_TERM_OPTIONS = [
  { value: "10", label: "10 Years" },
  { value: "15", label: "15 Years" },
  { value: "20", label: "20 Years" },
]

export const PAYMENT_FREQUENCY_OPTIONS = [
  { value: "annually", label: "Annually" },
  { value: "monthly", label: "Monthly" },
]

export const SORT_OPTIONS = [
  { value: "relevance", label: "Relevance" },
  { value: "price-low", label: "Price: Low to High" },
  { value: "price-high", label: "Price: High to Low" },
]

export const PLAN_TYPE_OPTIONS = [
  { value: "all", label: "All Plans" },
  { value: "individual", label: "Individual" },
  { value: "sme", label: "SME" },
]
